import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-129" data-mp="3msjh38l7co9v">
      <SectionHeading eyebrow="Frequently asked questions" title="Everything You Need to Know" data-id="element-130" data-mp="3muw6u7x7c2xh" />
      <div className="mx-auto mt-10 max-w-3xl divide-y divide-navy/10 border-y border-navy/10" data-id="element-131" data-mp="3rtz0yxbn8oqo">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-132" data-mp="3i09y6cii8oh3" data-mpi={i}>
              <h3 data-id="element-133" data-mp="9m9pvhefq5a5">
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left font-display text-lg font-extrabold text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric" data-id="element-134" data-mp="9lrhxnieu2me">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#1474D4] transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-135" data-mp="2aimitlgmvjb8" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-136" data-mp="2ehljgtvc0twv">
                {isOpen && <motion.div id={`faq-${i}`} initial={reduce ? false : {
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={reduce ? {
              opacity: 0
            } : {
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-137" data-mp="2tecnjgfyatst">
                    <p className="pb-5 text-[15px] leading-relaxed text-navy/75 sm:text-base" data-id="element-138" data-mp="1js8h9ti3opos">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
      <SectionCTA tone="light" label="Get instant access now — $27" data-id="element-139" data-mp="1xq6totcv2c1n" />
    </section>;
}